import { all, takeLatest, fork } from "redux-saga/effects";
import {
  handleLogin,
  handleForgotPassword,
  handleRefreshToken,
  handleLogout,
  handleSendEmail2FA,
} from "./handlers/auth";

import {
  login,
  forgotPassword,
  refreshToken,
  logout,
  emailSend2FA,
} from "../slices/authSlice";
import { getList, loadMore } from "../slices/vehicleSlice";
import { handleGetList, handleLoadMore } from "./handlers/vehicle";
import {
  handleLoadMoreOffsite,
  handleOffsiteGetList,
} from "./handlers/offsite";
import { getOffsiteList, loadMoreOffsite } from "../slices/offsiteSlice";

function* watchLogin() {
  yield takeLatest(login.type, handleLogin);
}

function* watchForgotPassword() {
  yield takeLatest(forgotPassword.type, handleForgotPassword);
}

function* watchGetList() {
  yield takeLatest(getList.type, handleGetList);
}

function* watchOffsiteGetList() {
  yield takeLatest(getOffsiteList.type, handleOffsiteGetList);
}

function* watchLoadMore() {
  yield takeLatest(loadMore.type, handleLoadMore);
}

function* watchLoadMoreOffsite() {
  yield takeLatest(loadMoreOffsite.type, handleLoadMoreOffsite);
}

function* watchRefreshToken() {
  yield takeLatest(refreshToken.type, handleRefreshToken);
}

// function* watchGetNotificationList() {
//   yield takeLatest(getNotificationList.type, handleGetNotificationList);
// }

function* watchLogout() {
  yield takeLatest(logout.type, handleLogout);
}

function* watchEmailSend2FA() {
  yield takeLatest(emailSend2FA.type, handleSendEmail2FA);
}

export default function* rootSaga() {
  yield all([
    fork(watchLogin),
    fork(watchForgotPassword),
    fork(watchGetList),
    fork(watchLoadMore),
    fork(watchLogout),
    fork(watchRefreshToken),
    fork(watchEmailSend2FA),

    // new offsite work
    fork(watchOffsiteGetList),
    fork(watchLoadMoreOffsite),

    // fork(watchGetNotificationList),
  ]);
}
